import { render, staticRenderFns } from "./groupLogDetails.vue?vue&type=template&id=d8bd5c94&"
import script from "./groupLogDetails.vue?vue&type=script&lang=js&"
export * from "./groupLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports